const highlights = [
  { icon: "ri-shield-star-line", title: "入れ歯専門クリニック", desc: "総入れ歯・部分入れ歯の専門クリニックとして長年の実績を誇ります。" },
  { icon: "ri-time-line", title: "1日完成コース", desc: "朝から夕方までの1回の通院で入れ歯を完成させる独自のシステム。" },
  { icon: "ri-map-pin-line", title: "札幌大通に所在", desc: "札幌中心部の便利な立地でアクセスしやすいクリニックです。" },
  { icon: "ri-chat-smile-3-line", title: "丁寧なカウンセリング", desc: "患者さまのご要望や不安に寄り添い、納得いただけるまでご説明します。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-stone-50">
      <div className="max-w-5xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16">
          <span className="inline-block text-teal-700 text-sm font-semibold tracking-widest uppercase mb-3">About Clinic</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            クリニックについて
          </h2>
          <div className="w-12 h-0.5 bg-amber-500 mx-auto" />
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* Text */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-5 leading-snug" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              「入れ歯を急いで作りたい」<br />
              そんな方を全力でサポートします
            </h3>
            <p className="text-gray-600 text-sm leading-8 mb-6">
              入れ歯を紛失した、壊れてしまった——そんな緊急時でも、当クリニックなら<strong className="text-teal-700">たった1回の通院</strong>で新しい入れ歯をお渡しすることができます。
            </p>
            <p className="text-gray-600 text-sm leading-8 mb-6">
              札幌に拠点を置く入れ歯専門クリニックとして、患者さまの口腔状態を丁寧に診察し、フィット感と見た目の美しさにこだわった入れ歯を提供しています。
            </p>
            <p className="text-gray-600 text-sm leading-8">
              料金は入れ歯の種別に関わらず<strong className="text-teal-700">1床33万円（税込）</strong>の明瞭会計。上下セットは<strong className="text-teal-700">55万円（税込）</strong>のお得な割引料金でご提供しております。
            </p>
          </div>

          {/* Image */}
          <div className="rounded-xl overflow-hidden h-80 w-full">
            <img
              src="https://static.readdy.ai/image/90b8495d3de38d7de3b4d3abd2a2907e/d753b20ef287c1b1e3a7d5649652be0a.jpeg"
              alt="クリニック内観"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Highlights */}
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
          {highlights.map((h) => (
            <div key={h.title} className="bg-white rounded-xl border border-gray-100 p-6 flex flex-col">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-lg mb-4">
                <i className={`${h.icon} text-teal-700 text-xl`} />
              </div>
              <h4 className="text-sm font-bold text-gray-900 mb-2">{h.title}</h4>
              <p className="text-xs text-gray-500 leading-relaxed">{h.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
